const LOCAL_KEY = '$$local'
const DATA_KEY = '$$local_data'
const EXPIRE = '$$local_expire'
export function setLocal(key, data, option) {
  const { storeKey, storage, expire } = format(key, option)
  if (data) {
    const storeData = JSON.stringify({
      [DATA_KEY]: data,
      [EXPIRE]: Date.now() + expire
    })
    try {
      storage.setItem(storeKey, storeData)
    } catch (e) {
      // 存满了 清了全部再存
      storage.clear()
      storage.setItem(storeKey, storeData)
    }
    return true
  }
  return false
}

export function getLocal(key, option) {
  const { storeKey, storage } = format(key, option)
  let item = storage.getItem(storeKey)
  if (item) {
    try {
      item = JSON.parse(item)
      const deadline = item[EXPIRE]
      if (Date.now() < deadline) {
        return item[DATA_KEY]
      }
    } catch (e) {
      console.error(e)
    }
  }
}

function format(key, option = {}) {
  // 默认缓存1小时
  const { session = true, expire = 1000 * 60 * 60 } = option
  return {
    storeKey: `${LOCAL_KEY}_${key}`,
    storage: session ? window.sessionStorage : window.localStorage,
    expire
  }
}
